<template>
  <div
    class="flex flex-col items-center justify-start number-field-xs pt-5">
    <div
      :class="{
        'mb-1 text-gray-400 opacity-0': true,
        'opacity-100': hovering || focused
      }">
      <span class="text-xs">Stück</span>
      <span v-if="item.unit" class="text-center text-xs">, VE ({{item.unit}} Stk.)</span>
    </div>
    <VueNumberInput
      v-model="quantity"
      size="small"
      controls
      :step="item.unit ? item.unit : 1"
      placeholder="-"
      :min="0"
      :max="atypicalQuantity"
      :class="{
        'w-full mx-1': true,
        'hide-controls': !hovering && !focused,
        'highlight-value': quantity > 0
      }" />

    <div v-if="quantity >= (atypicalQuantity - 20)" class="text-grey-600 my-2 text-xs text-center max-w-xs">
      Wenn Sie mehr als <b>{{ atypicalQuantity }} Einheiten</b> bestellen möchten, melden Sie sich bei unserem Kundenservice.
    </div>
    <div v-if="!isQuantityValid" class="text-red-600 my-2 text-sm text-center">
      Bitte beachten Sie die VE von {{ item.unit }}. <br>
      <button
        v-if="recommendedQuantity"
        class="underline"
        @click.prevent="() => (quantity = recommendedQuantity)">
        Auf {{ recommendedQuantity }} ändern
      </button>
    </div>
    <CopyOrderQuantity
      v-if="hovering && value === original"
      :date="date"
      :item="item"
      @change="val => this.quantity = val" />
  </div>
</template>

<script>
import VueNumberInput from '@chenfengyuan/vue-number-input'

import CopyOrderQuantity from './CopyOrderQuantity'

export default {
  name: 'ProductQuantityField',
  components: { VueNumberInput, CopyOrderQuantity },
  props: {
    item: {
      type: Object,
      required: true
    },
    hovering: {
      type: Boolean,
      default: false
    },
    value: {
      type: Number,
      default: 0
    },
    original: {
      type: Number,
      default: 0
    },
    date: {
      type: Date,
      required: true
    }
  },

  data: () => ({
    focused: false,
    quantity: 0,
  }),

  computed: {
    isQuantityValid() {
      if (this.item.unit && this.item.unit > 0) {
        return this.quantity % this.item.unit === 0
      }

      return true
    },

    recommendedQuantity() {
      return this.isQuantityValid
            ? this.quantity
            : Math.ceil(this.quantity / this.item.unit) * this.item.unit
    },

    atypicalQuantity() {
      return this.item.primary_category?.atypical_quantity ?? 400
    }
  },

  watch: {
    value: function(newValue) {
      this.quantity = newValue
    },

    quantity: function(newValue) {
      if (this.isQuantityValid) {
        this.$emit('update', newValue)
      } else if (isNaN(newValue)) {
        this.$emit('update', 0)
      }
    }
  },

  mounted() {
    const input = this.$el.querySelector('.vue-number-input__input')

    this.quantity = this.value

    if (input) {
      input.addEventListener('focus', this.onFocus)
      input.addEventListener('blur', this.onBlur)
    }
  },

  beforeDestroy() {
    const input = this.$el.querySelector('.vue-number-input__input')
    if (input) {
      input.removeEventListener('focus', this.onFocus)
      input.removeEventListener('blur', this.onBlur)
    }
  },

  methods: {
    onFocus() {
      this.focused = true
    },

    onBlur() {
      this.focused = false
    },
  }
}
</script>

<style scoped>
.number-field-xs >>> .vue-number-input--small {
  max-width: 100px;
}
.number-field-xs >>> .vue-number-input--small.vue-number-input--controls > button.vue-number-input__button {
  width: 1.5rem;
}

.number-field-xs >>> .vue-number-input--small.vue-number-input--controls > input.vue-number-input__input {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  height: 24px;
  line-height: 1;
}

.number-field-xs >>> .hide-controls.vue-number-input--small.vue-number-input--controls > button.vue-number-input__button {
  opacity: 0 !important;
}

.number-field-xs >>> .hide-controls.vue-number-input--small.vue-number-input--controls > input.vue-number-input__input {
  border-color: transparent !important;
  background-color: transparent !important;
  color: rgba(0, 0, 0, 0.3) !important;
}

.number-field-xs >>> .highlight-value.vue-number-input--small.vue-number-input--controls > input.vue-number-input__input {
  color: rgba(0, 0, 0, 1) !important;
  font-weight: 600 !important;
  font-size: 18px !important;
}

</style>
